function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, JSON, Object, shortCode, shortUrlCopied, shortUrlLoading) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }
    return {
      value: (h("div", {
        "class": Object.assign({}, {
          'hidden': $attr(`hidden`),
          'support-widget-present': $attr(`is-support-widget-present`),
        }, {
          'global-action-bar-container': true
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'global-action-bar-container-item': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((shortCode) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-short-url-result': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("input", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  type: 'text',
                  readonly: true
                }),
                "props": {
                  value: $helpers.getShortUrl()
                },
                "hook": {
                  insert: ({
                    elm
                  }) => $helpers.handleShortUrlInputInsert(elm)
                },
                "class": {
                  'mp-short-url-input': true
                },
              }));
              __jade_nodes = __jade_nodes.concat((shortUrlCopied) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-drop-menu", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    direction: 'up',
                    'with-caret': true,
                    open: true,
                  }),
                  "on": {
                    close: $helpers.clearShortUrlCopied,
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'mp-short-url-copied': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat("Link copied!");;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);
              __jade_nodes = __jade_nodes.concat(h("div", (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-button", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    icon: 'duplicate',
                    theme: 'tertiary',
                  }),
                  "on": {
                    click: $helpers.copyShortUrl,
                  },
                  "class": {
                    'mp-short-url-copy': true
                  },
                }));
                __jade_nodes = __jade_nodes.concat(h("mp-tooltip", (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Copy");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("div", (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-button", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    icon: 'x',
                    theme: 'tertiary',
                  }),
                  "on": {
                    click: $helpers.closeShortUrl,
                  },
                  "class": {
                    'mp-short-url-close': true
                  },
                }));
                __jade_nodes = __jade_nodes.concat(h("mp-tooltip", (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Close");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-button", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  icon: shortUrlLoading ? 'spinner' : 'link',
                  theme: 'tertiary',
                }),
                "on": {
                  click: $helpers.createShortUrl,
                },
                "class": {
                  'mp-short-url-create': true
                },
              }));
              __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  placement: 'left'
                }),
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Generate short link");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "shortCode" in locals ? locals.shortCode : typeof shortCode !== "undefined" ? shortCode : undefined, "shortUrlCopied" in locals ? locals.shortUrlCopied : typeof shortUrlCopied !== "undefined" ? shortUrlCopied : undefined, "shortUrlLoading" in locals ? locals.shortUrlLoading : typeof shortUrlLoading !== "undefined" ? shortUrlLoading : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;